import { areaCalc } from 'features/fde/repairPlanning/annotationAreaCalculator'
import {
  CustomCorrosionRegion,
  GeckoComponent,
  GeckoComponentModel,
  GeckoMarkupRect,
  RolodexEntryPutJson,
  RolodexEntryType,
} from 'types'

interface MarkupPrimitive {
  x_start: number
  y_start: number
  x_end: number
  y_end: number
  kind: string
}

// This function is used to map the custom corrosion regions to markup layers
// this is being done in order to black box the RL generation with custom corrosion
//regions irrespective of schema changes on the markup layers
export const MapCorrosionRegionsToMarkupLayers = (
  customCorrosionRegions: CustomCorrosionRegion[],
  selectedComponent: GeckoComponent
): RolodexEntryPutJson[] => {
  return customCorrosionRegions.map((region) => {
    return {
      id: region.id,
      type: RolodexEntryType.MARKUP_LAYER,
      data: {
        name: region.name,
        corrosionRate: region.corrosionRate,
        category: 'corrosion-region',
        geometry: {
          x_start: region.xStart,
          y_start: region.yStart,
          x_end: region.xEnd,
          y_end: region.yEnd,
          x_measurement_unit: region.xMeasurementUnit,
          y_measurement_unit: region.yMeasurementUnit,
          type: 'rect',
        },
        primitives: {
          [region.id]: {
            x_start: region.xStart,
            y_start: region.yStart,
            x_end: region.xEnd,
            y_end: region.yEnd,
            kind: 'rect',
          },
        },
      },
      tags: {
        component: selectedComponent?.id ?? null,
        ...selectedComponent?.tags,
      },
      index: {},
    }
  })
}

export function getCustomCorrosionRegionArea({
  customCorrosionRegions,
  selectedComponent,
  selectedComponentModel,
}: {
  customCorrosionRegions: CustomCorrosionRegion[]
  selectedComponent: GeckoComponent
  selectedComponentModel: GeckoComponentModel
}): number | null {
  if (!customCorrosionRegions.length) {
    return null
  }
  const customMarkupLayers = MapCorrosionRegionsToMarkupLayers(
    customCorrosionRegions,
    selectedComponent
  )

  const markupPrimitives = customMarkupLayers.map((layer) => {
    const primitveValues = Object.values(
      layer.data['primitives']!
    )[0] as MarkupPrimitive

    return {
      rect: {
        start: {
          x: {
            num: primitveValues.x_start,
          },
          y: {
            num: primitveValues.y_start,
          },
        },
        end: {
          x: {
            num: primitveValues.x_end,
          },
          y: {
            num: primitveValues.y_end,
          },
        },
      },
      kind: 'rect',
    } as unknown as GeckoMarkupRect
  })

  return areaCalc(markupPrimitives, selectedComponentModel)
}
